export * from './sidenav';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/material/sidenav/index.js
// module id = ../../../material/sidenav/index.js
// module chunks = 3